module.exports = __webpack_public_path__ + "static/media/cartWarningLogo.cb654a05.svg";